import type { SxProps, Theme } from '@mui/material';
import type { CSSProperties } from 'react';

export const styles = {
    logoImg: {
        maxWidth: '130px',
        height: 'auto',
        padding: '4px',
    } as CSSProperties,
    logoText: {
        marginTop: '24px',
        marginBottom: '24px',
        fontWeight: 400,
        fontSize: '32px',
    } as SxProps<Theme>,
    forgotPassword: {} as SxProps<Theme>,
    forgotPasswordDisabled: {
        color: '#CAD2D9',
        cursor: 'default',
        '&:hover': { textDecoration: 'none' },
    } as SxProps<Theme>,
    formStack: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: '20px',
    } as SxProps<Theme>,
};
